import React, { useState } from 'react';
import '../Video/Video.css';
import { FaPlayCircle } from "react-icons/fa";

const Video = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  const handlePlayButtonClick = () => {
    setShowOverlay(true);
  };

  const handleCloseOverlay = () => {
    setShowOverlay(false);
  };
  
  return (
    <div className="video-section">
      <h1 className="video-title" data-aos="fade-down">श्री Var Event & Conference Presents</h1>
      <div className="video-thumbnail" data-aos="zoom-out">
        <img 
          src="/videothumb.avif" 
          alt="Video Thumbnail" 
          className="thumbnail-image" 
          loading="lazy"  // lazy loading for the thumbnail image
        />
        <button 
          className="play-button" 
          onClick={handlePlayButtonClick}
        >
          <FaPlayCircle className='play-icon'/>
        </button>
      </div>
      {showOverlay && (
        <div className="video-overlay-v">
          <div className="overlay-content-v">
            <button className="close-button-v" onClick={handleCloseOverlay}>
              &times;
            </button>
            <video 
              className="video-frame"
              controls
              autoPlay
              preload="none"
              poster="/videothumb.avif"  // poster shows before video loads
            >
              <source src="/ved.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </div>
  );
};

export default Video;
